import React, { useState, useEffect, useCallback }from "react";

import HorizontalScroll from "src/components/HorizontalScroll/HorizontalScroll";
import Button from "src/components/Button/Button";

import "./TabContent.scss";

export interface ITab {
  name: string,
  actions: ITabAction[],
  onClick?(): void,
  badge?: number,
  badgeColor?: string
}

export interface ITabAction {
  label: string,
  onClick(): void
}

interface IProps {
  activeTab: number,
  setTab(index: number): void,
  tabs: ITab[],
  children: any,
  loading?: boolean,
  defaultTab?: number,
  className?: any,
  hideTabs?: boolean
}

export const useTabContent = () => {
  const [activeTab, setActiveTab] = useState<number>(0);

  const setTab = useCallback((index: number) => {
    setActiveTab(index);
  }, []);

  return { activeTab, setTab };
}

const TabContent: React.FC<IProps> = (props) => {
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (!loaded) {
      if (props.defaultTab) {
        props.setTab(props.defaultTab);
      }

      setLoaded(true);
    }
  }, [loaded, props, setLoaded]);

  if (!props.loading) {
    return (
      <div className={props.className ? props.className + " TabContent" : "TabContent"}>
        {!props.hideTabs && <HorizontalScroll className="tabs">
          {props.tabs.map((t:ITab, index:number) => {
            return(<li key={index} onClick={() => { if (t.onClick) { t.onClick(); } props.setTab(index); }} className={index === props.activeTab ? "active no-select" : "no-select"}>{t.name}{t.badge != null && t.badge > 0 && <span className="tabBadge" style={{ background: t.badgeColor || '#F97316' }}>{t.badge > 99 ? '99+' : t.badge}</span>}</li>);
          })}
          {props.tabs[props.activeTab].actions && props.tabs[props.activeTab].actions.length > 0 && (
            <li className="actions">
              {props.tabs[props.activeTab].actions.map((action:ITabAction, tIndex:number) => {
                return(<Button key={tIndex} onClick={(e) => { e.preventDefault(); e.stopPropagation(); action.onClick(); }}>{action.label}</Button>);
              })}
            </li>
          )}
        </HorizontalScroll>}
        <div className="content">
          {!Array.isArray(props.children) && <div className="tabContent active" data-index={0}>{props.children}</div>}
          {Array.isArray(props.children) && props.children.filter((child: any) => child !== false).map((child:JSX.Element | boolean, index:number) => {
            // Use the child's key prop if available, otherwise fall back to index
            const childKey = (child as any)?.key || `tab-${index}`;
            return(
              <div key={childKey} data-index={index} className={props.activeTab === index ? "tabContent active" : "tabContent"}>
                {child}
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return(
      <div className="TabContent skeleton">
        <div className="details"></div>
      </div>
    );
  }
};

export default TabContent;